import React from 'react';
import { createFileRoute, useNavigate } from '@tanstack/react-router';

import PostbacksLogs from '@pages/postbacks-logs/ui/PostbacksLogs';

function PostbacksLogsRoute() {
  const navigate = useNavigate();
  return <PostbacksLogs navigate={navigate} />;
}

export const Route = createFileRoute('/_auth/_layout/postbacks_logs')({
  component: PostbacksLogsRoute,
});
